module.exports = __webpack_public_path__ + "img/brain-map.7c4c7621.png";